import React from "react";
import { observer } from "mobx-react";
import AddInScheduleForm from "components/Workout/AddInScheduleForm";
import { Container, Content, Title, Header, Wrapper } from "./styles";
import { useTranslation } from "react-i18next";

type AddInSchedulePopupProps = {
  onClose: () => void;
};

const AddInSchedulePopup = observer((props: AddInSchedulePopupProps) => {
  const { onClose } = props;
  const { t } = useTranslation();

  return (
    <Container>
      <Content>
        <Header>
          <Title>{t("actions.add-in-schedule")}</Title>
        </Header>
        <Wrapper>
          <AddInScheduleForm onSubmit={onClose} />
        </Wrapper>
      </Content>
    </Container>
  );
});

export default AddInSchedulePopup;
